export const MUI_DATAGRID_KEY =
  "afae021779f7fa7bffc882b87c25720eTz0xMjE5NjksRT0xNzk1MDQ2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y";
